// import React, { useState } from "react";
// import {
//   FaCopy,
//   FaSync,
//   FaCheckCircle,
//   FaTimesCircle,
// } from "react-icons/fa";

// const GroupInvite = () => {
//   const groupList = [
//     "Y2FwaV9ncm91cDo5MTg5MTkxNzE5ODU6MTIwMzYzNDA0NTQyMTcwODAy",
   
//   ];

//   const [selectedGroup, setSelectedGroup] = useState("");
//   const [inviteLink, setInviteLink] = useState("");
//   const [highlight, setHighlight] = useState(false);

//   const [selectedJoinGroup, setSelectedJoinGroup] = useState("");
//   const [joinRequests, setJoinRequests] = useState([]);

//   // 📌 GET INVITE LINK
//   const getInviteLink = async () => {
//     if (!selectedGroup) return alert("Select Group");

//     const response = await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/getInviteLink.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedGroup }),
//       }
//     );

//     const data = await response.json();
//     setInviteLink(data.invite_link || "");
//     setHighlight(true);
//   };

//   // ♻ RESET INVITE LINK
//   const resetInviteLink = async () => {
//     if (!selectedGroup) return alert("Select Group");

//     const response = await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/resetInviteLink.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedGroup }),
//       }
//     );

//     const data = await response.json();
//     setInviteLink("");
//     setHighlight(false);
//     alert("Invite link reset successfully!");
//   };

//   // 📋 COPY INVITE LINK
//   const copyInviteLink = () => {
//     navigator.clipboard.writeText(inviteLink);
//     alert("Link copied!");
//   };

//   // 🔎 GET ALL JOIN REQUESTS
//   const getJoinRequests = async () => {
//     if (!selectedJoinGroup) return alert("Select Group");

//     const response = await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/getAllJoinRequests.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedJoinGroup }),
//       }
//     );

//     const data = await response.json();
//     setJoinRequests(data.requests || []);
//   };

//   // ✔ APPROVE JOIN REQUEST
//   const approveRequest = async (reqId) => {
//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/approveJoinRequest.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           groupId: selectedJoinGroup,
//           joinRequestId: reqId,
//         }),
//       }
//     );

//     setJoinRequests((prev) => prev.filter((r) => r.request_id !== reqId));
//   };

//   // ❌ REJECT JOIN REQUEST
//   const rejectRequest = async (reqId) => {
//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/rejectJoinRequest.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           groupId: selectedJoinGroup,
//           joinRequestId: reqId,
//         }),
//       }
//     );

//     setJoinRequests((prev) => prev.filter((r) => r.request_id !== reqId));
//   };

//   return (
//     <div style={styles.container}>

//       {/* -------------------- INVITE LINK SECTION -------------------- */}
//       <h2 style={styles.title}>Group Invite Link</h2>

//       <select
//         style={styles.dropdown}
//         value={selectedGroup}
//         onChange={(e) => setSelectedGroup(e.target.value)}
//       >
//         <option value="">Select Group ID</option>
//         {groupList.map((g, i) => (
//           <option key={i} value={g}>
//             {g}
//           </option>
//         ))}
//       </select>

//       <button style={styles.btn} onClick={getInviteLink}>
//         Get Invite Link
//       </button>

//       {inviteLink && (
//         <div style={styles.linkBox(highlight)}>
//           <span>{inviteLink}</span>
//           <div style={styles.iconRow}>
//             <FaCopy style={styles.icon} onClick={copyInviteLink} />
//             <FaSync style={styles.icon} onClick={resetInviteLink} />
//           </div>
//         </div>
//       )}

//       {/* -------------------- JOIN REQUEST SECTION -------------------- */}
//       <h2 style={styles.title}>Join Requests</h2>

//       <select
//         style={styles.dropdown}
//         value={selectedJoinGroup}
//         onChange={(e) => setSelectedJoinGroup(e.target.value)}
//       >
//         <option value="">Select Group ID</option>
//         {groupList.map((g, i) => (
//           <option key={i} value={g}>
//             {g}
//           </option>
//         ))}
//       </select>

//       <button style={styles.btn} onClick={getJoinRequests}>
//         Load Join Requests
//       </button>

//       <div>
//         {joinRequests.map((req, index) => (
//           <div key={index} style={styles.requestCard}>
//             <span style={styles.reqNumber}>{req.user_mobile}</span>

//             <div style={styles.iconRow}>
//               <FaCheckCircle
//                 style={styles.approveIcon}
//                 onClick={() => approveRequest(req.request_id)}
//               />
//               <FaTimesCircle
//                 style={styles.rejectIcon}
//                 onClick={() => rejectRequest(req.request_id)}
//               />
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default GroupInvite;


// const styles = {
//   container: {
//     width: "90%",
//     maxWidth: "600px",
//     margin: "20px auto",
//     padding: "20px",
//     background: "#fff",
//     borderRadius: "14px",
//     boxShadow: "0 5px 25px rgba(0,0,0,0.08)",
//     fontFamily: "Poppins",
//   },
//   title: {
//     marginBottom: "10px",
//     color: "#0158a2",
//     fontSize: "20px",
//     fontWeight: "600",
//   },
//   dropdown: {
//     width: "100%",
//     padding: "10px",
//     borderRadius: "10px",
//     border: "1px solid #ccc",
//     marginBottom: "10px",
//     fontSize: "15px",
//   },
//   btn: {
//     width: "100%",
//     padding: "12px",
//     background: "#0158a2",
//     color: "#fff",
//     border: "none",
//     borderRadius: "12px",
//     marginBottom: "15px",
//     cursor: "pointer",
//     fontWeight: "600",
//   },

//   linkBox: (highlight) => ({
//     padding: "12px",
//     background: highlight ? "#e8f3ff" : "#f4f4f4",
//     borderRadius: "10px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     border: highlight ? "1px solid #0158a2" : "1px solid #ccc",
//     transition: "0.3s",
//   }),
//   iconRow: {
//     display: "flex",
//     gap: "12px",
//     marginLeft: "10px",
//   },
//   icon: {
//     fontSize: "20px",
//     cursor: "pointer",
//   },

//   requestCard: {
//     padding: "12px 15px",
//     background: "#f2f7ff",
//     borderRadius: "12px",
//     marginBottom: "12px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
//   },
//   reqNumber: {
//     fontWeight: "600",
//     fontSize: "16px",
//   },
//   approveIcon: {
//     color: "#27ae60",
//     fontSize: "22px",
//     cursor: "pointer",
//   },
//   rejectIcon: {
//     color: "#e74c3c",
//     fontSize: "22px",
//     cursor: "pointer",
//   },
// };



// import React, { useState } from "react";
// import {
//   FaCopy,
//   FaSync,
//   FaCheckCircle,
//   FaTimesCircle,
// } from "react-icons/fa";

// const GroupInvite = () => {
//   const groupList = [
//     "Y2FwaV9ncm91cDo5MTg5MTkxNzE5ODU6MTIwMzYzNDA0NTQyMTcwODAy",
//   ];

//   const [selectedGroup, setSelectedGroup] = useState("");
//   const [inviteLink, setInviteLink] = useState("");
//   const [highlight, setHighlight] = useState(false);

//   const [selectedJoinGroup, setSelectedJoinGroup] = useState("");
//   const [joinRequests, setJoinRequests] = useState([]);

//   // 📌 GET INVITE LINK
//   const getInviteLink = async () => {
//     if (!selectedGroup) return alert("Select Group");

//     const response = await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/getInviteLink.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedGroup }),
//       }
//     );

//     const data = await response.json();
//     setInviteLink(data.invite_link || "");
//     setHighlight(true);
//   };

//   // ♻ RESET INVITE LINK
//   const resetInviteLink = async () => {
//     if (!selectedGroup) return alert("Select Group");

//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/resetInviteLink.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedGroup }),
//       }
//     );

//     setInviteLink("");
//     setHighlight(false);
//     alert("Invite link reset successfully!");
//   };

//   // 📋 COPY INVITE LINK
//   const copyInviteLink = () => {
//     navigator.clipboard.writeText(inviteLink);
//     alert("Link copied!");
//   };

//   // 🔎 GET ALL JOIN REQUESTS
//   const getJoinRequests = async () => {
//     if (!selectedJoinGroup) return alert("Select Group");

//     const response = await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/getAllJoinRequests.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedJoinGroup }),
//       }
//     );

//     const data = await response.json();
//     setJoinRequests(data.data || []); // ✔ Correct key
//   };

//   // ✔ APPROVE JOIN REQUEST
//   const approveRequest = async (reqId) => {
//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/approveJoinRequest.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           groupId: selectedJoinGroup,
//           joinRequestId: reqId,
//         }),
//       }
//     );

//     alert("User Approved!");

//     setJoinRequests((prev) =>
//       prev.filter((r) => r.join_request_id !== reqId)
//     );
//   };

//   // ❌ REJECT JOIN REQUEST  (Also removes from group)
//   const rejectRequest = async (reqId, mobile) => {
//     // 1️⃣ Reject API
//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/rejectJoinRequest.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           groupId: selectedJoinGroup,
//           joinRequestId: reqId,
//         }),
//       }
//     );

//     // 2️⃣ Remove User From Group API
//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/removeUserFromGroup.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           groupId: selectedJoinGroup,
//           userMobile: mobile,
//         }),
//       }
//     );

//     alert("User Rejected & Removed!");

//     setJoinRequests((prev) =>
//       prev.filter((r) => r.join_request_id !== reqId)
//     );
//   };

//   return (
//     <div style={styles.container}>
//       {/* -------------------- INVITE LINK SECTION -------------------- */}
//       <h2 style={styles.title}>Group Invite Link</h2>

//       <select
//         style={styles.dropdown}
//         value={selectedGroup}
//         onChange={(e) => setSelectedGroup(e.target.value)}
//       >
//         <option value="">Select Group ID</option>
//         {groupList.map((g, i) => (
//           <option key={i} value={g}>
//             {g}
//           </option>
//         ))}
//       </select>

//       <button style={styles.btn} onClick={getInviteLink}>
//         Get Invite Link
//       </button>

//       {inviteLink && (
//         <div style={styles.linkBox(highlight)}>
//           <span>{inviteLink}</span>
//           <div style={styles.iconRow}>
//             <FaCopy style={styles.icon} onClick={copyInviteLink} />
//             <FaSync style={styles.icon} onClick={resetInviteLink} />
//           </div>
//         </div>
//       )}

//       {/* -------------------- JOIN REQUEST SECTION -------------------- */}
//       <h2 style={styles.title}>Join Requests</h2>

//       <select
//         style={styles.dropdown}
//         value={selectedJoinGroup}
//         onChange={(e) => setSelectedJoinGroup(e.target.value)}
//       >
//         <option value="">Select Group ID</option>
//         {groupList.map((g, i) => (
//           <option key={i} value={g}>
//             {g}
//           </option>
//         ))}
//       </select>

//       <button style={styles.btn} onClick={getJoinRequests}>
//         Load Join Requests
//       </button>

//       <div>
//         {joinRequests.map((req, index) => (
//           <div key={index} style={styles.requestCard}>
//             <span style={styles.reqNumber}>{req.wa_id}</span>

//             <div style={styles.iconRow}>
//               <FaCheckCircle
//                 style={styles.approveIcon}
//                 onClick={() => approveRequest(req.join_request_id)}
//               />
//               <FaTimesCircle
//                 style={styles.rejectIcon}
//                 onClick={() =>
//                   rejectRequest(req.join_request_id, req.wa_id)
//                 }
//               />
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default GroupInvite;

// const styles = {
//   container: {
//     width: "90%",
//     maxWidth: "600px",
//     margin: "20px auto",
//     padding: "20px",
//     background: "#fff",
//     borderRadius: "14px",
//     boxShadow: "0 5px 25px rgba(0,0,0,0.08)",
//     fontFamily: "Poppins",
//   },
//   title: {
//     marginBottom: "10px",
//     color: "#0158a2",
//     fontSize: "20px",
//     fontWeight: "600",
//   },
//   dropdown: {
//     width: "100%",
//     padding: "10px",
//     borderRadius: "10px",
//     border: "1px solid #ccc",
//     marginBottom: "10px",
//     fontSize: "15px",
//   },
//   btn: {
//     width: "100%",
//     padding: "12px",
//     background: "#0158a2",
//     color: "#fff",
//     border: "none",
//     borderRadius: "12px",
//     marginBottom: "15px",
//     cursor: "pointer",
//     fontWeight: "600",
//   },

//   linkBox: (highlight) => ({
//     padding: "12px",
//     background: highlight ? "#e8f3ff" : "#f4f4f4",
//     borderRadius: "10px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     border: highlight ? "1px solid #0158a2" : "1px solid #ccc",
//     transition: "0.3s",
//   }),
//   iconRow: {
//     display: "flex",
//     gap: "12px",
//     marginLeft: "10px",
//   },
//   icon: {
//     fontSize: "20px",
//     cursor: "pointer",
//   },

//   requestCard: {
//     padding: "12px 15px",
//     background: "#f2f7ff",
//     borderRadius: "12px",
//     marginBottom: "12px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
//   },
//   reqNumber: {
//     fontWeight: "600",
//     fontSize: "16px",
//   },
//   approveIcon: {
//     color: "#27ae60",
//     fontSize: "22px",
//     cursor: "pointer",
//   },
//   rejectIcon: {
//     color: "#e74c3c",
//     fontSize: "22px",
//     cursor: "pointer",
//   },
// };



// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import {
//   FaCopy,
//   FaSync,
//   FaCheckCircle,
//   FaTimesCircle,
// } from "react-icons/fa";
// import './GroupInvite.css'

// const GroupInvite = () => {
//   const [groupList, setGroupList] = useState([]);          // ← NEW: REAL GROUP LIST
//   const [selectedGroup, setSelectedGroup] = useState("");
//   const [inviteLink, setInviteLink] = useState("");
//   const [highlight, setHighlight] = useState(false);

//   const [selectedJoinGroup, setSelectedJoinGroup] = useState("");
//   const [joinRequests, setJoinRequests] = useState([]);
// const [loadingRequests, setLoadingRequests] = useState(false);

//   const [pid, setPid] = useState(null);
  
//     useEffect(() => {
//       const loggedUser = JSON.parse(sessionStorage.getItem("user"));
//       if (!loggedUser) return;
  
//       const emailToUse =
//         loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;
  
//       axios
//         .get(
//           `https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(
//             emailToUse
//           )}`
//         )
//         .then((response) => {
//           const userData = response.data;
//           if (userData.p_id) {
//             setPid(userData.p_id);
//             fetchGroups(userData.p_id);
//           }
//         })
//         .catch((err) => console.error("PID Load Error:", err));
//     }, []);


//     const fetchGroups = async (pidValue) => {
//     try {
//       const res = await axios.post(
//         "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
//         {
//           pid: pidValue,
//           limit: 50,
//           after:  "",
//           before: "",
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );
      
// console.log('this is res',res.data)
//       setGroupList(res.data.data || []);
//     } catch (err) {
//       console.error("Error fetching groups:", err);
//     }
//   };
//   //  useEffect(() => {
//   //     fetchGroups();
//   // }, []);


//   // -----------------------------------------------------------------------
//   // 📌 GET INVITE LINK
//   // -----------------------------------------------------------------------
//   const getInviteLink = async () => {
//     if (!selectedGroup) return alert("Select Group");

//     const response = await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/getInviteLink.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedGroup }),
//       }
//     );

//     const data = await response.json();
//     setInviteLink(data.invite_link || "");
//     setHighlight(true);
//   };

//   // -----------------------------------------------------------------------
//   // ♻ RESET INVITE LINK
//   // -----------------------------------------------------------------------
//   const resetInviteLink = async () => {
//     if (!selectedGroup) return alert("Select Group");

//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/resetInviteLink.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedGroup }),
//       }
//     );

//     setInviteLink("");
//     setHighlight(false);
//     alert("Invite link reset successfully!");
//   };

//   // -----------------------------------------------------------------------
//   // 📋 COPY INVITE LINK
//   // -----------------------------------------------------------------------
//   const copyInviteLink = () => {
//     navigator.clipboard.writeText(inviteLink);
//     alert("Link copied!");
//   };

//   // -----------------------------------------------------------------------
//   // 🔎 LOAD JOIN REQUESTS
//   // -----------------------------------------------------------------------
//   const getJoinRequests = async () => {
//     if (!selectedJoinGroup) return alert("Select Group");
//       setLoadingRequests(true);
//   setJoinRequests([]);



//     const response = await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/getAllJoinRequests.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ groupId: selectedJoinGroup }),
//       }
//     );

//     const data = await response.json();
//     setJoinRequests(data.data || []);
//     setLoadingRequests(false);
//   };

//   // -----------------------------------------------------------------------
//   // ✔ APPROVE JOIN REQUEST
//   // -----------------------------------------------------------------------
//   const approveRequest = async (reqId) => {
//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/approveJoinRequest.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           groupId: selectedJoinGroup,
//           joinRequestId: reqId,
//         }),
//       }
//     );

//     alert("User Approved!");

//     setJoinRequests((prev) =>
//       prev.filter((r) => r.join_request_id !== reqId)
//     );
//   };

//   // -----------------------------------------------------------------------
//   // ❌ REJECT JOIN REQUEST & REMOVE USER
//   // -----------------------------------------------------------------------
//   const rejectRequest = async (reqId, mobile) => {
//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/rejectJoinRequest.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           groupId: selectedJoinGroup,
//           joinRequestId: reqId,
//         }),
//       }
//     );

//     await fetch(
//       "https://emedha.com/echatbot/enotifier/groups/removeUserFromGroup.php",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           groupId: selectedJoinGroup,
//           userMobile: mobile,
//         }),
//       }
//     );

//     alert("User Rejected & Removed!");

//     setJoinRequests((prev) =>
//       prev.filter((r) => r.join_request_id !== reqId)
//     );
//   };

//   return (
//     <div style={styles.container}>
//       {/* -------------------------------- INVITE LINK -------------------------------- */}
//       <h2 style={styles.title}>Group Invite Link</h2>

//       <select
//         style={styles.dropdown}
//         value={selectedGroup}
//         onChange={(e) => setSelectedGroup(e.target.value)}
//       >
//         <option value="">Select Group ID</option>

//         {groupList.map((g, i) => (
//           <option key={i} value={g.id}>
//             {/* {g.group_id} */}
//             {g.subject}
//           </option>
//         ))}
//       </select>

//       <button style={styles.btn} onClick={getInviteLink}>
//         Get Invite Link
//       </button>

//       {inviteLink && (
//         <div style={styles.linkBox(highlight)}>
//           <span>{inviteLink}</span>
//           <div style={styles.iconRow}>
//             <FaCopy style={styles.icon} onClick={copyInviteLink} />
//             <FaSync style={styles.icon} onClick={resetInviteLink} />
//           </div>
//         </div>
//       )}

//       {/* -------------------------------- JOIN REQUESTS -------------------------------- */}
//       <h2 style={styles.title}>Join Requests</h2>

//       <select
//         style={styles.dropdown}
//         value={selectedJoinGroup}
//         onChange={(e) => setSelectedJoinGroup(e.target.value)}
//       >
//         <option value="">Select Group ID</option>

//         {groupList.map((g, i) => (
//           <option key={i} value={g.id}>
//             {g.subject}
//           </option>
//         ))}
//       </select>

//       <button style={styles.btn} onClick={getJoinRequests}>
//         Load Join Requests
//       </button>

//       {/* <div>
//         {joinRequests.map((req, index) => (
//           <div key={index} style={styles.requestCard}>
//             <span style={styles.reqNumber}>{req.wa_id}</span>

//             <div style={styles.iconRow}>
//               <FaCheckCircle
//                 style={styles.approveIcon}
//                 onClick={() => approveRequest(req.join_request_id)}
//               />
//               <FaTimesCircle
//                 style={styles.rejectIcon}
//                 onClick={() =>
//                   rejectRequest(req.join_request_id, req.wa_id)
//                 }
//               />
//             </div>
//           </div>
//         ))}
//       </div> */}
//       <div style={{ marginTop: "10px" }}>
//   {/* ⏳ Loader */}
//   {loadingRequests && (
//     <div style={styles.loaderBox}>
//       <div className="spinner" style={styles.spinner}></div>
//       <p style={styles.loaderText}>
//         Checking join requests for <b>{groupList.find(g=>g.id===selectedJoinGroup)?.subject}</b>...
//       </p>
//     </div>
//   )}

//   {/* ❌ No Requests */}
//   {!loadingRequests && joinRequests.length === 0 && selectedJoinGroup && (
//     <p style={styles.noDataText}>
//       No join requests for <b>{groupList.find(g=>g.id===selectedJoinGroup)?.subject}</b>.
//     </p>
//   )}

//   {/* ✔ Requests Found */}
//   {joinRequests.map((req, index) => (
//     <div key={index} style={styles.requestCard}>
//       <span style={styles.reqNumber}>{req.wa_id}</span>

//       <div style={styles.iconRow}>
//         <FaCheckCircle
//           style={styles.approveIcon}
//           onClick={() => approveRequest(req.join_request_id)}
//         />
//         <FaTimesCircle
//           style={styles.rejectIcon}
//           onClick={() => rejectRequest(req.join_request_id, req.wa_id)}
//         />
//       </div>
//     </div>
//   ))}
// </div>

//     </div>
//   );
// };

// export default GroupInvite;

// const styles = {
//   container: {
//     width: "90%",
//     maxWidth: "600px",
//     margin: "20px auto",
//     padding: "20px",
//     background: "#fff",
//     borderRadius: "14px",
//     boxShadow: "0 5px 25px rgba(0,0,0,0.08)",
//     fontFamily: "Poppins",
//   },
//   title: {
//     marginBottom: "10px",
//     color: "#0158a2",
//     fontSize: "20px",
//     fontWeight: "600",
//   },
//   dropdown: {
//     width: "100%",
//     padding: "10px",
//     borderRadius: "10px",
//     border: "1px solid #ccc",
//     marginBottom: "10px",
//     fontSize: "15px",
//   },
//   btn: {
//     width: "100%",
//     padding: "12px",
//     background: "#0158a2",
//     color: "#fff",
//     border: "none",
//     borderRadius: "12px",
//     marginBottom: "15px",
//     cursor: "pointer",
//     fontWeight: "600",
//   },
//   linkBox: (highlight) => ({
//     padding: "12px",
//     background: highlight ? "#e8f3ff" : "#f4f4f4",
//     borderRadius: "10px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     border: highlight ? "1px solid #0158a2" : "1px solid #ccc",
//     transition: "0.3s",
//   }),
//   iconRow: {
//     display: "flex",
//     gap: "12px",
//     marginLeft: "10px",
//   },
//   icon: {
//     fontSize: "20px",
//     cursor: "pointer",
//   },
//   requestCard: {
//     padding: "12px 15px",
//     background: "#f2f7ff",
//     borderRadius: "12px",
//     marginBottom: "12px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     boxShadow: "0 3px 8px rgba(0,0,0,0.06)",
//   },
//   reqNumber: {
//     fontWeight: "600",
//     fontSize: "16px",
//   },
//   approveIcon: {
//     color: "#27ae60",
//     fontSize: "22px",
//     cursor: "pointer",
//   },
//   rejectIcon: {
//     color: "#e74c3c",
//     fontSize: "22px",
//     cursor: "pointer",
//   },
//   loaderBox: {
//   background: "#f0f7ff",
//   padding: "15px",
//   borderRadius: "12px",
//   textAlign: "center",
//   marginBottom: "10px",
//   boxShadow: "0 3px 10px rgba(0,0,0,0.06)"
// },
// spinner: {
//   width: "28px",
//   height: "28px",
//   border: "4px solid #cce3ff",
//   borderTop: "4px solid #0158a2",
//   borderRadius: "50%",
//   margin: "0 auto 10px",
//   animation: "spin 1s linear infinite",
// },
// loaderText: {
//   fontSize: "15px",
//   color: "#0158a2",
//   fontWeight: "500",
// },
// noDataText: {
//   background: "#fff3cd",
//   padding: "12px",
//   borderRadius: "10px",
//   textAlign: "center",
//   color: "#856404",
//   fontWeight: "500",
//   border: "1px solid #ffeeba",
//   marginBottom: "12px"
// }

// };


// import React from "react";
// import { Link, RefreshCw } from "lucide-react";

// export default function GroupInvite() {
//   // Common reusable styles to keep the code clean and readable
//   const styles = {
//     pageWrapper: {
//       padding: "24px",
//       fontFamily: "system-ui, sans-serif",
//       maxWidth: "800px",
//       margin: "0 auto",
//     },
//     header: {
//       marginBottom: "24px",
//     },
//     titleContainer: {
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//     },
//     title: {
//       fontSize: "24px",
//       fontWeight: "600",
//       margin: 0,
//     },
//     subtitle: {
//       fontSize: "14px",
//       color: "#6b7280",
//       marginTop: "4px",
//       marginBottom: 0,
//     },
//     formCard: {
//       background: "#ffffff",
//       border: "1px solid #e5e7eb",
//       borderRadius: "8px",
//       padding: "20px",
//       marginBottom: "20px",
//       boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//     },
//     cardTitle: {
//       fontSize: "18px",
//       fontWeight: "600",
//       marginBottom: "16px",
//       marginTop: 0,
//     },
//     grid: {
//       display: "grid",
//       gridTemplateColumns: "1fr",
//       gap: "16px",
//     },
//     fieldGroup: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "6px",
//     },
//     label: {
//       fontSize: "14px",
//       fontWeight: "500",
//       color: "#374151",
//     },
//     required: {
//       color: "#ef4444",
//       marginLeft: "2px",
//     },
//     select: {
//       width: "100%",
//       padding: "8px 12px",
//       borderRadius: "6px",
//       border: "1px solid #d1d5db",
//       backgroundColor: "#fff",
//       fontSize: "14px",
//       outline: "none",
//     },
//     btnContainer: {
//       display: "flex",
//       gap: "8px",
//       marginTop: "20px",
//     },
//     primaryBtn: {
//       display: "inline-flex",
//       alignItems: "center",
//       gap: "8px",
//       backgroundColor: "#2563eb",
//       color: "#ffffff",
//       padding: "8px 16px",
//       borderRadius: "6px",
//       border: "none",
//       fontSize: "14px",
//       fontWeight: "500",
//       cursor: "pointer",
//     },
//   };

//   return (
//     <div style={styles.pageWrapper}>
//       {/* Page Header / Wrapper Title */}
//       <header style={styles.header}>
//         <div style={styles.titleContainer}>
//           <Link size={17} style={{ color: "#2563eb" }} />
//           <h1 style={styles.title}>Group Invite Link</h1>
//         </div>
//         <p style={styles.subtitle}>Manage group invitations and participant join requests</p>
//       </header>

//       {/* Group Invite Link Section */}
//       <section style={styles.formCard}>
//         <h2 style={styles.cardTitle}>Group Invite Link</h2>
//         <div style={styles.grid}>
//           <div style={styles.fieldGroup}>
//             <label style={styles.label}>
//               Select Group ID <span style={styles.required}>*</span>
//             </label>
//             <select style={styles.select} required>
//               <option value="">-- Select a Group --</option>
//               <option value="Varahi Jewels">Varahi Jewels</option>
//               <option value="Emedha Emp Group">Emedha Emp Group</option>
//             </select>
//           </div>
//         </div>
//         <div style={styles.btnContainer}>
//           <button style={styles.primaryBtn} type="button">
//             <Link size={14} />
//             Get Invite Link
//           </button>
//         </div>
//       </section>

//       {/* Join Requests Section */}
//       <section style={styles.formCard}>
//         <h2 style={styles.cardTitle}>Join Requests</h2>
//         <div style={styles.grid}>
//           <div style={styles.fieldGroup}>
//             <label style={styles.label}>
//               Select Group ID <span style={styles.required}>*</span>
//             </label>
//             <select style={styles.select} required>
//               <option value="">-- Select a Group --</option>
//               <option value="Varahi Jewels">Varahi Jewels</option>
//               <option value="Emedha Emp Group">Emedha Emp Group</option>
//             </select>
//           </div>
//         </div>
//         <div style={styles.btnContainer}>
//           <button style={styles.primaryBtn} type="button">
//             <RefreshCw size={14} />
//             Load Join Requests
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }


import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, RefreshCw } from "lucide-react";
import {
  FaCopy,
  FaSync,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";

const styles = {
  pageWrapper: {
    padding: "24px",
    fontFamily: "system-ui, sans-serif",
    maxWidth: "800px",
    margin: "0 auto",
  },
  header: {
    marginBottom: "24px",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  title: {
    fontSize: "24px",
    fontWeight: "600",
    margin: 0,
  },
  subtitle: {
    fontSize: "14px",
    color: "#6b7280",
    marginTop: "4px",
    marginBottom: 0,
  },
  formCard: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "20px",
    marginBottom: "20px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "16px",
    marginTop: 0,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "16px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
  },
  required: {
    color: "#ef4444",
    marginLeft: "2px",
  },
  select: {
    width: "100%",
    padding: "8px 12px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    backgroundColor: "#fff",
    fontSize: "14px",
    outline: "none",
  },
  btnContainer: {
    display: "flex",
    gap: "8px",
    marginTop: "20px",
    flexDirection: "column",
  },
  primaryBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    padding: "8px 16px",
    borderRadius: "6px",
    border: "none",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    width: "fit-content",
  },
  linkBox: (highlight) => ({
    padding: "12px",
    background: highlight ? "#e8f3ff" : "#f4f4f4",
    borderRadius: "6px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: highlight ? "1px solid #2563eb" : "1px solid #e5e7eb",
    transition: "0.3s",
    marginTop: "16px",
  }),
  iconRow: {
    display: "flex",
    gap: "12px",
    marginLeft: "10px",
  },
  icon: {
    fontSize: "18px",
    cursor: "pointer",
    color: "#4b5563",
  },
  requestListContainer: {
    marginTop: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  requestCard: {
    padding: "12px 15px",
    background: "#f9fafb",
    borderRadius: "6px",
    border: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  reqNumber: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
  },
  approveIcon: {
    color: "#16a34a",
    fontSize: "20px",
    cursor: "pointer",
  },
  rejectIcon: {
    color: "#dc2626",
    fontSize: "20px",
    cursor: "pointer",
  },
  loaderBox: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    padding: "15px",
    borderRadius: "6px",
    textAlign: "center",
  },
  spinner: {
    width: "24px",
    height: "24px",
    border: "3px solid #e2e8f0",
    borderTop: "3px solid #2563eb",
    borderRadius: "50%",
    margin: "0 auto 10px",
    animation: "spin 1s linear infinite",
  },
  loaderText: {
    fontSize: "14px",
    color: "#475569",
    fontWeight: "400",
    margin: 0,
  },
  noDataText: {
    background: "#fffbeb",
    padding: "12px",
    borderRadius: "6px",
    textAlign: "center",
    color: "#b45309",
    fontWeight: "400",
    fontSize: "14px",
    border: "1px solid #fef3c7",
  }
};

const GroupInvite = () => {
  const [groupList, setGroupList] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [inviteLink, setInviteLink] = useState("");
  const [highlight, setHighlight] = useState(false);

  const [selectedJoinGroup, setSelectedJoinGroup] = useState("");
  const [joinRequests, setJoinRequests] = useState([]);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [pid, setPid] = useState(null);

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = `@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;
    document.head.appendChild(styleSheet);
    return () => { document.head.removeChild(styleSheet); };
  }, []);

  useEffect(() => {
    const loggedUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loggedUser) return;

    const emailToUse = loggedUser.role === "admin" ? loggedUser.email : loggedUser.adminEmail;

    axios
      .get(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
      .then((response) => {
        const userData = response.data;
        if (userData.p_id) {
          setPid(userData.p_id);
          fetchGroups(userData.p_id);
        }
      })
      .catch((err) => console.error("PID Load Error:", err));
  }, []);

  const fetchGroups = async (pidValue) => {
    try {
      const res = await axios.post(
        "https://emedha.com/echatbot/enotifier/groups/getAllGroups.php",
        { pid: pidValue, limit: 50, after: "", before: "" },
        { headers: { "Content-Type": "application/json" } }
      );
      setGroupList(res.data.data || []);
    } catch (err) {
      console.error("Error fetching groups:", err);
    }
  };

  const getInviteLink = async () => {
    if (!selectedGroup) return alert("Select Group");

    const response = await fetch(
      "https://emedha.com/echatbot/enotifier/groups/getInviteLink.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ groupId: selectedGroup }),
      }
    );

    const data = await response.json();
    setInviteLink(data.invite_link || "");
    setHighlight(true);
  };

  const resetInviteLink = async () => {
    if (!selectedGroup) return alert("Select Group");

    await fetch(
      "https://emedha.com/echatbot/enotifier/groups/resetInviteLink.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ groupId: selectedGroup }),
      }
    );

    setInviteLink("");
    setHighlight(false);
    alert("Invite link reset successfully!");
  };

  const copyInviteLink = () => {
    navigator.clipboard.writeText(inviteLink);
    alert("Link copied!");
  };

  const getJoinRequests = async () => {
    if (!selectedJoinGroup) return alert("Select Group");
    setLoadingRequests(true);
    setJoinRequests([]);

    const response = await fetch(
      "https://emedha.com/echatbot/enotifier/groups/getAllJoinRequests.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ groupId: selectedJoinGroup }),
      }
    );

    const data = await response.json();
    setJoinRequests(data.data || []);
    setLoadingRequests(false);
  };

  const approveRequest = async (reqId) => {
    await fetch(
      "https://emedha.com/echatbot/enotifier/groups/approveJoinRequest.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ groupId: selectedJoinGroup, joinRequestId: reqId }),
      }
    );

    alert("User Approved!");
    setJoinRequests((prev) => prev.filter((r) => r.join_request_id !== reqId));
  };

  const rejectRequest = async (reqId, mobile) => {
    await fetch(
      "https://emedha.com/echatbot/enotifier/groups/rejectJoinRequest.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ groupId: selectedJoinGroup, joinRequestId: reqId }),
      }
    );

    await fetch(
      "https://emedha.com/echatbot/enotifier/groups/removeUserFromGroup.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ groupId: selectedJoinGroup, userMobile: mobile }),
      }
    );

    alert("User Rejected & Removed!");
    setJoinRequests((prev) => prev.filter((r) => r.join_request_id !== reqId));
  };

  return (
    <div style={styles.pageWrapper}>
      {/* Page Header Area */}
      <header style={styles.header}>
        <div style={styles.titleContainer}>
          <Link size={17} style={{ color: "#2563eb" }} />
          <h1 style={styles.title}>Group Invite Link</h1>
        </div>
        <p style={styles.subtitle}>Manage group invitations and participant join requests</p>
      </header>

      {/* Group Invite Link Form Card */}
      <section style={styles.formCard}>
        <h2 style={styles.cardTitle}>Group Invite Link</h2>
        <div style={styles.grid}>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Select Group ID <span style={styles.required}>*</span>
            </label>
            <select
              style={styles.select}
              value={selectedGroup}
              onChange={(e) => setSelectedGroup(e.target.value)}
              required
            >
              <option value="">Select Group ID</option>
              {groupList.map((g, i) => (
                <option key={i} value={g.id}>
                  {g.subject}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div style={styles.btnContainer}>
          <button style={styles.primaryBtn} onClick={getInviteLink} type="button">
            <Link size={14} />
            Get Invite Link
          </button>
        </div>

        {inviteLink && (
          <div style={styles.linkBox(highlight)}>
            <span>{inviteLink}</span>
            <div style={styles.iconRow}>
              <FaCopy style={styles.icon} onClick={copyInviteLink} />
              <FaSync style={styles.icon} onClick={resetInviteLink} />
            </div>
          </div>
        )}
      </section>

      {/* Join Requests Form Card */}
      <section style={styles.formCard}>
        <h2 style={styles.cardTitle}>Join Requests</h2>
        <div style={styles.grid}>
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Select Group ID <span style={styles.required}>*</span>
            </label>
            <select
              style={styles.select}
              value={selectedJoinGroup}
              onChange={(e) => setSelectedJoinGroup(e.target.value)}
              required
            >
              <option value="">Select Group ID</option>
              {groupList.map((g, i) => (
                <option key={i} value={g.id}>
                  {g.subject}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div style={styles.btnContainer}>
          <button style={styles.primaryBtn} onClick={getJoinRequests} type="button">
            <RefreshCw size={14} />
            Load Join Requests
          </button>
        </div>

        <div style={styles.requestListContainer}>
          {/* ⏳ Loader */}
          {loadingRequests && (
            <div style={styles.loaderBox}>
              <div style={styles.spinner}></div>
              <p style={styles.loaderText}>
                Checking join requests for <b>{groupList.find((g) => g.id === selectedJoinGroup)?.subject || "Selected Group"}</b>...
              </p>
            </div>
          )}

          {/* ❌ No Requests */}
          {!loadingRequests && joinRequests.length === 0 && selectedJoinGroup && (
            <p style={styles.noDataText}>
              No join requests for <b>{groupList.find((g) => g.id === selectedJoinGroup)?.subject || "Selected Group"}</b>.
            </p>
          )}

          {/* ✔ Requests List */}
          {joinRequests.map((req, index) => (
            <div key={index} style={styles.requestCard}>
              <span style={styles.reqNumber}>{req.wa_id}</span>
              <div style={styles.iconRow}>
                <FaCheckCircle
                  style={styles.approveIcon}
                  onClick={() => approveRequest(req.join_request_id)}
                />
                <FaTimesCircle
                  style={styles.rejectIcon}
                  onClick={() => rejectRequest(req.join_request_id, req.wa_id)}
                />
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default GroupInvite;